import { getAuth } from 'firebase/auth';
import { getApps, getApp } from 'firebase/app';
import { createLogger } from './utils/logger';

const logger = createLogger('apiFetch');

// Get Firebase auth instance (will use the same app initialized in auth.js)
function getFirebaseAuth() {
	try {
		const apps = getApps();
		if (apps.length > 0) {
			const app = getApp();
			return getAuth(app);
		}
	} catch (error) {
		// Firebase not initialized yet, that's ok
	}
	return null;
}

export async function apiFetch(path, options = {}) {
	const base = process.env.REACT_APP_API_BASE || '';
	const url = `${base}${path}`;

	// Get Firebase ID token if available
	let headers = {
		'Content-Type': 'application/json',
		...options.headers,
	};

	try {
		const auth = getFirebaseAuth();
		if (auth) {
			const user = auth.currentUser;
			if (user) {
				const token = await user.getIdToken();
				if (token) {
					headers.Authorization = `Bearer ${token}`;
				}
			}
		}
	} catch (error) {
		logger.error('Error getting ID token:', error);
		// Continue without token if there's an error
	}

	const response = await fetch(url, {
		...options,
		headers,
	});

	// Handle 401 errors by redirecting to login (will be handled by RequireAuth)
	if (response.status === 401) {
		// If we're not already on a login page, the RequireAuth component will handle it
		const error = await response.json().catch(() => ({ error: 'Unauthorized' }));
		throw new Error(error.error || 'Unauthorized');
	}

	if (!response.ok) {
		const error = await response.json().catch(() => ({ error: `Request failed: ${response.status}` }));
		throw new Error(error.error || `Request failed: ${response.status}`);
	}

	return response.json();
}

// Helper for fetchJSON that matches existing usage
export async function fetchJSON(path, options = {}) {
	return apiFetch(path, options);
}

